import { GetterTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { ITicketState } from './ticket-state.store';
import { TicketActionAttachmentTypes } from '../../common/enums';
import { TicketListingViewModel } from '../../models/ticket';

export const getters: GetterTree<IRootState, ITicketState> = {
  activityStatus: (state: ITicketState) => state.activityStatus,
  actionLoading: (state: ITicketState) => state.actionLoading,
  service: (state: ITicketState) => {
    return state.service;
  },
  attachments: (state: ITicketState) => {
    return state.currentChannel.actions
      .filter(act => act.action_type === TicketActionAttachmentTypes.Attachment);
  },
  attachmentsInQueue: (state: ITicketState) => {
    return state.attachmentsInQueue.filter(doc => doc.percentage < 100);
  },
  ticket: (state: ITicketState) => state.ticket,
  tickets: (state: ITicketState) => state.tickets,
  ticketViewModels: (state: ITicketState) => (state.tickets || []).map(item => new TicketListingViewModel(item)),
  pagination: (state: ITicketState) => state.pagination,
  sideBarTickets: (state: ITicketState) => state.sideBarTickets,
  currentTicket: (state: ITicketState) => {
    return state.currentTicket
  },
  currentChannel: (state: ITicketState) => state.currentChannel,
  actions: (state: ITicketState) => state.currentChannel.actions,
  participants: (state: ITicketState) => state.currentChannel.participants,
  ticketParameter: (state: ITicketState) => state.ticketParameter,
  ticketSidebarParameter: (state: ITicketState) => state.ticketSidebarParameter,
  message: (state: ITicketState) => state.message,
  activity: (state: ITicketState, rootState) => {
    return 1;
  },
  needKeep: (state: ITicketState) => {
    return state.needKeep;
  },
  characterProblems: (state: ITicketState) => state.characterProblems,
  equipments: (state: ITicketState) => state.equipments,
  ticketClosureReasons: (state: ITicketState) => state.ticketClosureReasons,
  ticketReasons: (state: ITicketState) => state.ticketReasons,
  characterProblemsTranslation: (state: ITicketState) => {
    const result = {};
    state.characterProblems.level_1.forEach(x => result[x.id] = x.name);
    state.characterProblems.level_2.forEach(x => result[x.id] = x.name);
    return result;
  },
  appointments: (state: ITicketState) => {

    return state.appointments
  },
  ticketIndependentContractors: (state: ITicketState) => {
    return state.ticketIndependentContractors;
  },
  loaders: (state: ITicketState) => {
    return state.loaders
  },
  ticketPriorityLevels: (state: ITicketState) => state.ticketPriorityLevels,
  ticketSubstatus: (state: ITicketState) => state.ticketSubstatus,
  ticketProblemType: (state: ITicketState) => state.ticketProblemType,
}



// WEBPACK FOOTER //
// ./src/store/ticket/ticket-getters.store.ts